export default [
    {
        icon: "mdi-card-bulleted-settings", title: "template_setting", i18n: "template_setting", group: "template_setting",
        items: [
            {icon: "mdi-image-area", title: "Templates", name: "Templates", i18n: "Templates"},
            {icon: "mdi-image-size-select-large", title: "Templates_Size", name: "Templates_Size", i18n: "Templates_Size"},
            {icon: "mdi-image-size-select-large", title: "Templates_Type", name: "Templates_Type", i18n: "Templates_Type"},
            {icon: "mdi-artstation", title: "Themes", name: "Themes", i18n: "Themes"},
            {icon: "mdi-tag", title: "Tags", name: "Tags", i18n: "Tags"},
            {icon: "mdi-format-font", title: "Fonts", name: "Fonts", i18n: "Fonts"},
        ]
    },
    {icon: "mdi-cog", title: "custom_design_setting", name: "custom_design_setting", i18n: "custom_design_setting"},
    {icon: "mdi-cash-multiple", title: "Payments", name: "Payments", i18n: "Payments"},
    {icon: "mdi-account-group", title: "Users", name: "Users", i18n: "Users"},
    {icon: "mdi-cached", title: "DeleteCache", name: "DeleteCache", i18n: "delete_caches"},
];